import { execOnLoad } from '../helpers';
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import breakpoints from '../../../.bundler/breakpoints.json';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarousel = (context) => {
  const snippetContainer = context.classList.contains('.carousel__container')
    ? context
    : context.closest('.carousel__container');
  if (!snippetContainer) return;

  const sliderWrapper = snippetContainer.querySelector(
    '.carousel__slider-wrapper',
  );
  const slides = snippetContainer.querySelectorAll('.swiper-slide');
  if (!sliderWrapper || slides.length <= 1) return;

  const leftArrow = snippetContainer.querySelector('.carousel__arrow--left');
  const rightArrow = snippetContainer.querySelector('.carousel__arrow--right');
  const scrollbar = snippetContainer.querySelector('.carousel__scrollbar');
  const options = {
    modules: [
      ...(leftArrow && rightArrow ? [Navigation] : []),
      ...(scrollbar ? [Scrollbar] : []),
    ],
    ...(scrollbar ? { scrollbar: { el: scrollbar, draggable: true } } : {}),
    ...(leftArrow && rightArrow
      ? { navigation: { prevEl: leftArrow, nextEl: rightArrow } }
      : {}),
    spaceBetween: sliderWrapper.dataset.mobileGap ?? 0,
    slidesPerView: sliderWrapper.dataset.mobileSlides ?? 1,
    breakpoints: {
      [parseInt(breakpoints.lg.replace('px', ''))]: {
        spaceBetween: sliderWrapper.dataset.desktopGap ?? 0,
        slidesPerView: sliderWrapper.dataset.desktopSlides ?? 1,
      },
    },
  };
  new Swiper(sliderWrapper, options);
};

execOnLoad(window.dAgency.initCarousel, '.carousel__container');
